/**
 * GuestBadge — kennzeichnet Gäste (Mitglieder mit ausschließlich der Rolle `guest`).
 *
 * Icon aus der zentralen Matrix (`guest` → `UserPlusIcon`, Issue #9). Die
 * Information steckt im Text „Gast", die Farbe unterstützt nur.
 */
import React from 'react';
import { getAttributeIcon } from '../utils/attributeIcons';

const GuestIcon = getAttributeIcon('guest');

export interface GuestBadgeProps {
  /** `sm` für dichte Listen/Tabellen, `md` für Karten. */
  size?: 'sm' | 'md';
  className?: string;
}

const GuestBadge: React.FC<GuestBadgeProps> = ({ size = 'sm', className = '' }) => (
  <span
    className={`inline-flex flex-none items-center gap-1 rounded border border-info-200 bg-info-50 font-semibold text-info-700 dark:border-info-800/60 dark:bg-info-900/30 dark:text-info-300 ${
      size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs'
    } ${className}`.trim()}
    title="Gastmitglied"
  >
    {GuestIcon && <GuestIcon className="h-3 w-3" aria-hidden="true" focusable="false" />}
    Gast
  </span>
);

export default GuestBadge;
